module.exports = __webpack_public_path__ + "static/media/carta_68.dd361814.jpg";